import React, { useCallback, useContext } from 'react'
import ModalContext from 'contexts/ModalContext'
import getLoyaltyBenefitInfoModal from 'loyalty/lib/getLoyaltyBenefitInfoModal'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Clickable from 'components/Common/Clickable'
import { useIntl } from 'react-intl'

interface Props {
  inclusionId: string
}

function LoyaltyBenefitInfoIcon({ inclusionId }: Props) {
  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const InfoModal = getLoyaltyBenefitInfoModal(inclusionId)

  const handleClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (InfoModal) {
      showModal(<InfoModal />)
    }
  }, [showModal, InfoModal])

  if (!InfoModal) return null

  return (
    <Clickable
      onClick={handleClick}
      aria-label={intl.formatMessage({
        id: '5RCzJ9xYal0Vcw0Jf4UG',
        defaultMessage: 'Learn more about loyalty benefit',
      })}
    >
      <LineInfoCircleIcon size="S" colour="light-foreground-alt" />
    </Clickable>
  )
}

export default LoyaltyBenefitInfoIcon
